var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmericanFootball({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AD4700",
    d: "M3.92 7.853C5.595 6.09 7.61 4.666 9.674 3.795a14.094 14.094 0 0 1 2.803 4.829l.088.278a10.919 10.919 0 0 1-2.441 2.363A10.933 10.933 0 0 1 6.94 12.79c-.678-1.556-1.75-3.308-2.821-4.683l-.2-.253zm-.137-.167c-.496-.6-.983-1.105-1.421-1.457a10.92 10.92 0 0 1 2.513-2.461 10.92 10.92 0 0 1 3.073-1.49 8.694 8.694 0 0 1 1.573 1.35c-1.962.84-3.874 2.17-5.497 3.81l-.241.248zm8.872-4.738c.492-.07.979-.1 1.456-.09l.107.003v-.018c.354.53.376 1.515.059 2.673a17.263 17.263 0 0 0-1.402-2.274l-.22-.294zm-.151-.194c-.263-.331-.53-.64-.8-.921 1.067.089 1.911.383 2.347.81a9.213 9.213 0 0 0-1.235.068l-.312.043zM.807 12.227l.05.024.046-.096c.338-.7.734-1.38 1.18-2.034.717.913 1.378 2.02 1.837 3.107-1.499-.012-2.676-.4-3.113-1zm-.099-.162c-.336-.659-.266-1.848.219-3.188.339.298.682.662 1.016 1.07A16.387 16.387 0 0 0 .89 11.699l-.183.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.138 6.497c1.904 1.815 3.34 3.975 4.425 6.397l-.252.06a10.37 10.37 0 0 1-2.012.266c-.733-1.8-1.763-3.393-3.189-4.704.24-.772.811-1.791 1.027-2.019zm9.085-4.717a19.898 19.898 0 0 1 2.9 4.228c-.4 1.23-1.299 2.585-1.312 2.546-.861-2.586-2.25-4.797-4.426-6.45l.084-.03c.389-.123 1.535-.349 2.754-.294zM6.396 5.886l.08-.057C7.772 4.9 8.978 4.387 8.762 4.09c-.208-.288-1.294.253-2.538 1.132l-.204.147c-1.328.964-2.284 1.91-2.064 2.213.22.303 1.112-.733 2.439-1.697z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanFootball);
export default __webpack_public_path__ + "static/media/american_football.0193208184a85074473e4c9e433cfdf5.svg";
export { ForwardRef as ReactComponent };